import styled, { css } from "styled-components";
import { getBreakpoint, getDirection } from "../../../../themes/common";
import { theme } from "../theme/toyotaTheme";

type DisclaimerPropsType = {
    genericDisclaimer: boolean;
    collapsed: boolean;
    shouldCollapse?: boolean;
    fullHeight: number;
    hasDarkBackground?: boolean;
};

export const Button = styled.button`
    display: flex;
    font-family: ${theme.fonts.base};
    font-size: 1.3rem;
    line-height: 2rem;
    color: ${theme.colors.primaryBlack};
`;

export const Badge = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    padding: 1px 6px 3px;
    font-family: ${theme.fonts.regular};
    font-size: 1.2rem;
    line-height: 2.2rem;
    color: ${theme.colors.grey7};
    background-color: ${theme.colors.primaryWhite};
    border: 2px solid ${theme.colors.grey7};
    border-radius: 10px;
`;

export const Text = styled.div`
    margin-bottom: ${theme.space[4]}px;
    font-family: ${theme.fonts.base};
    font-size: 1.3rem;
    letter-spacing: 0;
    line-height: 2rem;
    text-align: ${getDirection("left")};
    color: ${theme.colors.grey7};

    p {
        margin-bottom: ${theme.space[1]}px;
    }
`;

export const DisclaimerContainer = styled.div`
    padding-block: ${theme.space[6]}px;

    @supports not (padding-block: 0) {
        padding: ${theme.space[6]}px 0;
    }
`;

export const DisclaimerList = styled.ul`
    margin: 0;
    padding: 0;
    list-style: none;
`;
export const Wrapper = styled.li<DisclaimerPropsType>`
    &:not(:last-child) {
        margin-bottom: ${theme.space[4]}px;
    }

    ${Text} {
        position: relative;
        margin-bottom: ${theme.space[1]}px;

        ${({ shouldCollapse, collapsed, genericDisclaimer, hasDarkBackground }) =>
            shouldCollapse &&
            !genericDisclaimer &&
            css`
                max-height: ${collapsed ? "60px" : `auto`};
                padding-bottom: 20px;
                transition: max-height 0.3s;
                overflow: hidden;

                &:after {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    height: 40px;
                    content: "";
                    background: ${hasDarkBackground
                        ? "linear-gradient(to right, rgba(245, 245, 245, 0.5), #f5f5f5 75%, #f5f5f5)"
                        : "linear-gradient(to right, rgba(255, 255, 255, 0.5), #fff 75%, #fff)"};
                    transition: opacity 0.3s;
                    opacity: ${collapsed ? 1 : 0};
                }
            `};

        ${({ shouldCollapse, collapsed, genericDisclaimer }) =>
            shouldCollapse &&
            genericDisclaimer &&
            css`
                @media ${getBreakpoint("down", "md")} {
                    max-height: ${!collapsed ? "auto" : "60px"};
                    overflow: hidden;
                }
            `};
    }
`;

export const Title = styled.h2`
    display: flex;
    align-items: center;
    max-width: 100%;
    margin-bottom: ${theme.space[1]}px;
    font-family: ${theme.fonts.regular};
    font-size: 1.3rem;
    line-height: 2rem;
    text-transform: uppercase;
    color: ${theme.colors.grey7};

    ${Badge} {
        margin-${getDirection("right")}: ${theme.space[1]}px;
    }
`;
